import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-provalt-banner-collectable',
  standalone: true,
  imports: [
    NgForOf,
    RouterLink
  ],
  templateUrl: './provalt-banner-collectable.component.html',
  styleUrl: './provalt-banner-collectable.component.css'
})
export class ProvaltBannerCollectableComponent {

  departments = [
    {name: "Ain", code: '01'},
    {name: "Alpes de Haute-Provence", code: '04'},
    {name: "Hautes-Alpes", code: '05'},
    {name: "Doubs", code: '25'},
    {name: "Isère", code: '38'},
    {name: "Jura", code: '39'},
    {name: "Loire", code: '42'},
    {name: "Rhône", code: '69'},
    {name: "Saône & Loire", code: '71'},
    {name: "Savoie", code: '73'},
    {name: "Haute-Savoie", code: '74'},
  ]

}
